import { useCachedFetch } from '@structural-climbing/auth'

export function useGymOccupancy(gymId: string | null, apiUrl: string): number {
  // Short TTL — occupancy shifts as people check in and out, but a few seconds
  // of sharing across call sites still spares the endpoint the duplicate hits.
  const { data } = useCachedFetch<number>(
    gymId ? `gym-occupancy:${gymId}` : null,
    async () => {
      const res = await fetch(`${apiUrl}/gym-occupancy/${gymId}`)
      if (!res.ok) throw new Error('Failed to load occupancy')
      const body = (await res.json()) as { count: number }
      return body.count
    },
    { ttlMs: 15_000 },
  )

  return data ?? 0
}
